/**
 * Replaces the Nuxt-3-only `@zadigetvoltaire/nuxt-gtm` module (removed in
 * Phase 2 of the Nuxt 4 migration). Deliberately injects the script
 * imperatively via document.createElement, matching the playbook's sample
 * exactly - see NUXT4-MIGRATION-PROGRESS.md's Phase 3 notes for why that
 * choice carries a known Cookiebot-compatibility risk that needs manual
 * verification in staging, not just this plugin working locally.
 */
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (!config.public.gtm?.enabled || !config.public.gtm?.id) {
    return;
  }

  const gtmId = config.public.gtm.id;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
});
